<template>
    <div class="l-ss-c-search-results-wrapper">
        <popup
            :opened="store.state.ui.isFiltersOpened"
            :show-close-icon="false"
            class="l-ss-c-search-popup-filters-popup"
            @close="() => toggleFilters(false)">
            <section-full-filters
                :filters="filterItems"
                :has-results="hasResults"
                :has-selected="hasFilters"
                :total-items-count="totalItemsCount"
                :values="filterValues"
                :all-categories-list="allCategoriesList"
                :all-categories-tree="allCategoriesTree"
                :currency="currencyInOffers"
                :loading-by-filters="loadingByFilters"
                @filters-change="onFilterChange"
                @filter-click="emitFilterClick"
                @close="() => toggleFilters(false)"
                @reset="emitResetFilters"/>
        </popup>

        <age-check-popup
            v-if="isShowAgeCheckPopup"
            :is-show="true"
            @close="toggleAgeCheckPopup"
            @age-confirmed="$emit('age-confirmed')"/>

        <div
            class="l-ss-c-search-popup-content"
            :class="{
                'l-ss-c-filters-left': filterPositionLeft,
                'l-ss-c-search-popup-content-masked': showMask
            }"
            :style="!$configuration.showInput ? 'padding-top: 0' : ''">
            <section-image
                v-if="base64Image && !isShowImageSearchInFilters"
                :key="base64ImageKey"
                :base-image="base64Image"
                :store="store"
                @search="onImageSearch"/>
            <div
                v-if="isShowResultsLoader"
                class="l-ss-c-results-loader">
                <pulse-dots/>
            </div>

            <template v-else>
                <section-results-info
                    v-if="isResultsVisible && totalItemsCount"
                    :search="search"
                    :total-items-count="totalItemsCount"
                    @autocomplete-search="onAutocompleteSearch"
                    @params-search="emitParamsSearch"
                    @result-tab-click="emitResultTabClick"
                    @handle-tags-click="onTapAction"/>

                <div :class="{ 'l-ss-c-filters-left-container': filterPositionLeft }">
                    <section-filters
                        v-if="showFilters"
                        ref="sectionFilters"
                        :currency="currencyInOffers"
                        :filter-position-left="filterPositionLeft"
                        :filters="filterItems"
                        :has-results="hasResults"
                        :has-selected="hasFilters"
                        :show-sorting="showSorting"
                        :sort-by="sortBy"
                        :sort-dest="sortDest"
                        :total-items-count="totalItemsCount"
                        :values="filterValues"
                        :all-categories-list="allCategoriesList"
                        :is-show-signature="isShowSignature"
                        :store="store"
                        :base64-image="base64Image"
                        :base64-image-key="base64ImageKey"
                        search-type="search-results"
                        class="l-ss-c-search-popup-content-wrapper-child"
                        v-on="sectionFiltersEventListeners"/>
                    <section-results
                        v-if="isResultsVisible"
                        ref="search-results"
                        :categories="allCategoriesList"
                        :all-categories-tree="allCategoriesTree"
                        :category-id="resultsCategoryId"
                        :store="store"
                        :error-text="requestErrorText"
                        :filter-position-left="filterPositionLeft"
                        :filters="filterItems"
                        :filter-values="filterValues"
                        :group-categories="$configuration.features.shouldGroupCategories"
                        :has-filters="hasFilters"
                        :has-loaded-once="hasLoadedOnce"
                        :has-query="hasQuery"
                        :has-results="hasResults"
                        :is-loading="isLoading"
                        :loading-by-filters="loadingByFilters"
                        :loading-next-page="loadingNextPage"
                        :limit="limit"
                        :currency="currencyInOffers"
                        :search="searchResponse"
                        :search-request-id="searchRequestId"
                        :search-state="searchState"
                        :skip="skip"
                        :templates="offerTemplates"
                        :total-items-count="totalItemsCount"
                        :query="query"
                        :sort-by="sortBy"
                        :sort-dest="sortDest"
                        :show-sorting="showSorting"
                        :adult-permission-confirmed="adultPermissionConfirmed"
                        :is-show-signature="isShowSignature"
                        :has-top-offers="hasTopOffers"
                        class="l-ss-c-search-popup-content-wrapper-child"
                        v-on="sectionResultsEventListeners"/>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import SectionResults from '@/core/components/section-results/section-results.vue';
    import SectionFilters from '@/core/components/filters/section-filters';
    import SectionImage from '@/core/components/section-image';
    import Popup from '@/core/components/popup';
    import SectionFullFilters from '@/core/components/filters/section-full-filters';
    import ClickOutside from '@/core/directives/clickOutside.js';
    import store from '@/core/store';
    import AgeCheckPopup from '@/core/components/age-check-popup.vue';
    import PulseDots from '@/core/components/pulse-dots.vue';
    import SectionResultsInfo from '@/core/components/section-results/section-results-info.vue';
    import EventEmitterMixin from '@/core/mixins/event-emitter';
    import {
        mapHandlers,
        commonOfferEventHandlers,
        commonSearchResultsWrapperEventHandlers,
    } from '@/core/mixins/event-emitter';

    export default {
        components: {
            SectionResultsInfo,
            PulseDots,
            AgeCheckPopup,
            SectionFilters,
            SectionResults,
            SectionImage,
            Popup,
            SectionFullFilters,
        },
        directives: {
            'click-outside': ClickOutside,
        },
        mixins: [EventEmitterMixin],
        props: {
            search: {
                type: Object,
                required: false,
                default: () => null,
            },
            from_completions: {
                type: String,
                default: '',
            },
            filterValues: {
                type: Array,
            },
            currencyInOffers: {
                type: String,
                default: '',
            },
            sortDest: {
                type: String,
                default: '',
            },
            sortBy: {
                type: String,
                default: '',
            },
            isShowSort: {
                type: Boolean,
                default: true,
            },
            filterItems: {
                type: Array,
            },
            offerTemplates: {
                type: Object,
                required: false,
            },
            skip: {
                type: [Number, String],
                default: '',
            },
            searchRequestId: {
                type: String,
                default: '',
            },
            searchResponse: {
                type: Object,
                required: false,
                default: () => null,
            },
            limit: {
                type: Number,
                default: 0,
            },
            isSearchLoading: {
                type: Boolean,
                default: false,
            },
            isCompletionsLoading: {
                type: Boolean,
                default: false,
            },
            loadingByFilters: {
                type: Boolean,
                default: false,
            },
            hasResults: {
                type: Boolean,
                default: false,
            },
            hasQuery: {
                type: Boolean,
                default: false,
            },
            hasLoadedOnce: {
                type: Boolean,
                default: false,
            },
            showResultsMask: {
                type: Boolean,
                default: false,
            },
            hasFilters: {
                type: Boolean,
                default: false,
            },
            errorTextCompletions: {
                type: String,
                default: '',
            },
            errorTextSearch: {
                type: String,
                default: '',
            },
            resultsCategoryId: {
                type: [String, Number, Array],
            },
            requestCategories: {
                type: Object,
                required: false,
                default: () => null,
            },
            isFiltersBlockVisible: {
                type: Boolean,
                default: false,
            },
            isResultsVisible: {
                type: Boolean,
                default: false,
            },
            totalItemsCount: {
                type: Number,
                default: 0,
            },
            query: {
                type: String,
                default: '',
            },
            searchState: {
                type: Object,
                default: () => ({
                    public: {},
                    private: {},
                }),
            },
            store: {
                required: true,
                type: Object,
                default: () => store,
            },
            isShowSignature: {
                type: Boolean,
                default: false,
            },
            adultPermissionConfirmed: {
                type: Boolean,
                default: false,
            },
            allCategoriesTree: {
                type: Array,
            },
            isAvailableShowMask: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                base64ImageKey: false,
                prevSearchResponse: [],
                loadingNextPage: false,
            };
        },
        computed: {
            topOfferIds() {
                return this.searchResponse?.topOffersIds || [];
            },
            hasTopOffers() {
                return !!this.topOfferIds.length;
            },
            filterPositionLeft() {
                return this.$configuration.layout.filterPosition === 'left' && !this.$screen.isMobile && this.totalItemsCount >
                    0;
            },
            requestErrorText() {
                return this.errorTextCompletions || this.errorTextSearch || '';
            },
            isCategoriesLoading() {
                return this.requestCategories ? this.requestCategories.isLoading : false;
            },
            isLoading() {
                return this.isCompletionsLoading || this.isSearchLoading || this.isCategoriesLoading;
            },
            categoriesResponse() {
                return this.requestCategories ? this.requestCategories.response : null;
            },
            allCategoriesList() {
                return this.categoriesResponse || [];
            },
            showSorting() {
                return (Boolean(this.hasResults) && this.isShowSort);
            },
            hasImageSearchResults() {
                return Boolean(this.searchState.private && this.searchState.private.image);
            },
            image() {
                return this.hasImageSearchResults ? this.searchState.private.image : '';
            },
            isShowAgeCheckPopup() {
                return this.store.state.ui.isShowAgeCheckPopup;
            },
            isShowResultsLoader() {
                if (this.loadingByFilters || this.loadingNextPage || !this.isSearchLoading) {
                    return false;
                }

                return this.isSearchLoading || (!this.isResultsVisible && this.hasResults);
            },
            showMask() {
                return this.isAvailableShowMask &&
                    (
                        this.showResultsMask ||
                        this.store.state.ui.isImageSearchVisible ||
                        this.store.state.ui.isVoiceSearchActive
                    );
            },
            base64Image() {
                return this.store.state.base64Image;
            },
            showFilters() {
                return this.isFiltersBlockVisible && this.isResultsVisible && !this.hasTopOffers && this.searchResponse?.offers?.length > 1;
            },
            isShowImageSearchInFilters() {
                return this.$configuration.isShowImageSearchInFilters && this.$configuration.layout.filterPosition === 'left';
            },
            sectionResultsEventListeners() {
                return {
                    ...mapHandlers(this, commonOfferEventHandlers),
                    ...mapHandlers(this, commonSearchResultsWrapperEventHandlers),
                    'click-adult': this.toggleAgeCheckPopup,
                    'filters-change': this.onFilterChange,
                    'navigate-page-next': this.handleNavigatePageNext,
                    'reset-category': this.onResetCategory,
                    'add-to-cart': args => this.emitAddToCart(args),
                    'handle-tags-click': value => this.onTapAction(value),
                    'result-category-click': value => this.emitResultCategoryClick(value),
                    'view-in-category-click': value => this.emitViewInCategoryClick(value),
                };
            },
            sectionFiltersEventListeners() {
                return {
                    'replace-image': this.toggleImagePicker,
                    'filters-change': this.onFilterChange,
                    'filter-click': params => this.emitFilterClick(params),
                    'sort-change': params => this.emitSortChange(params),
                    'result-sort-click': params => this.emitResultSortClick(params),
                    'reset-filters': () => this.emitResetFilters(),
                    'close-filters': () => this.toggleFilters(false),
                    'open-filters': () => this.toggleFilters(true),
                };
            },
        },
        watch: {
            'searchState.public': function (state) {
                if (state.query) {
                    this.resetImage();
                }
            },
            base64Image() {
                this.base64ImageKey = !this.base64ImageKey;

                if (this.isShowImageSearchInFilters) {
                    this.onImageSearch(this.base64Image);
                }
            },

            searchResponse(newSearchResponse, prevSearchResponse) {
                this.prevSearchResponse = prevSearchResponse;
            },

            isLoading(value) {
                if (!value) {
                    this.loadingNextPage = false;
                }
            },
        },
        methods: {
            onTapAction(value) {
                this.emitSearchInputChange({ query: value, focus: false });
                this.emitHandleSearch();
            },
            toggleFilters(value) {
                this.emitToggleFilters(value);
            },
            resetImage() {
                this.store.commit('base64Image/SET_PROPERTY', null);
            },
            onImageSearch(image) {
                this.emitSearchImage({ base64: image });
            },
            onResetCategory() {
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategorySearch', value: false });
                this.emitNavigateCategory({ skip: 0, categoryId: '' });
            },
            onAutocompleteSearch(value) {
                this.emitAutocompleteSearch(value);
            },
            onFilterChange({ field, ...params }) {
                let allowedFilters = [];

                if (this.filterItems.length) {
                    allowedFilters = this.filterItems.map(filter => filter.name);
                } else {
                    allowedFilters = this.prevSearchResponse?.params.map(filter => filter.name) || [];
                }

                const hasParams = !!Object.keys(params).length;
                const output = this.filterValues
                    .filter(filter => filter.field !== field && allowedFilters.includes(filter.field))
                    .slice(0);

                if (allowedFilters.includes(field) && hasParams) {
                    output.push({ field, ...params });
                }

                this.emitFiltersChange({ filters: output, changed: [field] });
            },
            handleNavigatePageNext() {
                this.loadingNextPage = true;
                this.emitNavigatePageNext();
            },
            toggleAgeCheckPopup() {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isShowAgeCheckPopup',
                    value: !this.store.state.ui.isShowAgeCheckPopup,
                });
            },
            toggleImagePicker(event) {
                this.emitToggleImagePicker();
                this.emitButtonImageClick(event);
            },
        },
    };
</script>
